export default {
  rates: {
    title: 'Tarieven van de leverancier',
    addRate: 'Tarief toevoegen',
    duplicateRate: 'Tarief dupliceren',
    editRate: 'Tarief bewerken',
    removeRate: 'Tarief verwijderen',
    list: 'Lijst met tarieven',
    rate: 'Tarief',
    minPax: 'Min Pax',
    maxPax: 'Max Pax',
    individualRate: 'Individueel Tarief',
    roomingRate: 'Rooming Tarief',
    supplement: 'Supplement',
    groupType: 'Groepstype',
    individual: 'Individueel',
    rooming: 'Rooming',
    supplierResource: 'Product van de leverancier',
    netPrice: 'Netto',
    commission: 'Commissie',
    grossPrice: 'Bruto',
    markToPay: 'Betaling op rekening',
    yes: 'Ja',
    no: 'Nee',
    markup: 'Marge',
    vat: 'BTW',
    isIncludedVat: 'Inclusief BTW',
    roomPriceType: 'Type kamerprijs',
    block: 'Blok',
    bookingForm: 'Boekingsformulier',
    status: 'Status',
    actions: 'Acties',
    pax: 'Passagier | Passagiers',
    roomingPlaceholder: '1 eenpersoons, 2 tweepersoons...',
    vatRate: 'BTW-tarief',
    addConcept: 'Concept toevoegen',
    commissionable: 'Commissieplichtig',
    commissionRate: 'Commissietarief',
    typeNoOptions: 'Geen types beschikbaar',
    categoryNoOptions: 'Geen categorieën beschikbaar',
    product: 'Product',
    type: 'Type',
    category: 'Categorie',
    initDate: 'Begindatum',
    endDate: 'Einddatum',
    price: 'Prijs',
    removeTitle: 'Tarief verwijderen',
    singleRate: 'U dupliceert het volgende tarief',
    blockRate: 'U dupliceert het volgende blok',
    removeText: "Weet u zeker dat u het tarief van product '{product}' wilt verwijderen? Als u het verwijdert, kunt u het niet meer herstellen.",
  },
  portal: {
    title: 'Supplier Portal',
    welcomeMessage: "Beheer uw boekingen en bekijk toekomstige schema's",
    noBookings: 'Geen boekingen gevonden',
    noBookingsSub: 'Er zijn geen boekingen om weer te geven voor de geselecteerde periode.',
    caseNumber: 'Dossier #',
    client: 'Klant',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    clientPhone: 'Telefoon',
    clientEmail: 'E-mail',
    clientAddress: 'Adres van de Klant',
    clientObservations: 'Klantopmerkingen',
    clientDetails: 'Klant Details',
    checkIn: 'Inchecken',
    checkOut: 'Uitchecken',
    nights: 'nachten',
    supplierName: 'Leverancier',
    location: 'Locatie',
    roomType: 'Kamertype',
    dates: 'Data',
    resource: 'Product',
    details: 'Details',
    price: 'Prijs',
    total: 'Totaal',
    status: 'Status',
    bookingStatus: 'Boeking',
    paymentStatus: 'Betaling',
    invoiceStatus: 'Factura',
    quantity: 'Aant',
    pax: 'Pax',
    upcoming: 'Aankomend',
    past: 'Verleden',
    searchLabel: 'Klant / Dossiernaam / Dossier #',
    searchPlaceholder: 'Zoeken op klant, dossiernaam of dossier #...',
    clearFilters: 'Filters wissen',
    clientTooltip: 'Klantgegevens zijn zichtbaar 48 uur voor inchecken',
    priceTooltip: 'Klik op het potloodicoon om uw prijs in te voeren',
    editPriceTooltip: 'Bewerk uw prijs',
    caseNumberTooltip: 'Intern boekingsreferentienummer',
  },
  sendPortalLink: 'Stuur portaal login link',
  sendPortalLinkConfirmTitle: 'Stuur portaal link',
  sendPortalLinkConfirmText: 'Weet u zeker dat u de portaal login link wilt sturen naar "{supplier}"?',
  sendPortalLinkSuccess: 'E-mail succesvol verzonden',
  sendPortalLinkError: 'Kon de e-mail niet verzenden',
  portalLoginLinkSection: 'Toegang tot leveranciersportaal',
  portalLoginLinkDescription: 'Stuur een e-mail naar de leverancier met de inloglink voor ons leveranciersportaal.',
};
